module.exports = __webpack_public_path__ + "static/tyrannosaurus_rex-f2708790284abe975006bc529b9c2db2.jpeg";